export const load = () => ({
	h1: 'Custom Storm Window Inserts: Find the Solution for your Problem',
	title: 'Comfort Solutions with Indow Custom Storm Window Inserts',
	description:
		'Learn how custom-made storm window insert fit inside your window frames to add comfort, soundproofing, UV protection, energy savings, privacy, & more.',
	showTitle: true,
});
